import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=5cfcb072&scoped=true"
var script = {}
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=5cfcb072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfcb072",
  null
  
)

export default component.exports